var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35801 5.17734V0.583008C3.14967 0.903841 0.583008 3.65659 0.583008 6.99967C0.583008 10.3428 3.14967 13.0955 6.35801 13.4163V8.82201C5.71634 8.55893 5.07467 7.84667 5.07467 6.99967C5.07467 6.15267 5.71634 5.44042 6.35801 5.17734ZM8.83484 6.35801H13.4163C13.1083 3.31009 10.8497 0.884591 7.64134 0.583008V5.17734C8.28301 5.36984 8.61667 5.80617 8.83484 6.35801ZM7.64134 8.82201V13.4163C10.8497 13.1148 13.1083 10.6893 13.4163 7.64134H8.83484C8.61667 8.19317 8.28301 8.62951 7.64134 8.82201Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutIcon);
export default __webpack_public_path__ + "static/media/donut-icon.6758adb6521e234e36c012c743744b57.svg";
export { ForwardRef as ReactComponent };